import useProtoMethod from "./useProtoMethod";
import {
  GetAdvisorActivityFeedRequest,
  GetAdvisorActivityFeedResponse,
  GetMemberActivityFeedRequest,
  GetMemberActivityFeedResponse,
  GetAdvisorPublicActivityFeedRequest,
  GetAdvisorPublicActivityFeedResponse,
  GetBotConversationFeedRequest,
  GetBotConversationFeedResponse,
} from "protogen/feed_service_pb";

const useGetAdvisorActivityFeed = (
  callback?: (r: GetAdvisorActivityFeedResponse) => void,
) => {
  return useProtoMethod<
    GetAdvisorActivityFeedRequest,
    GetAdvisorActivityFeedResponse
  >("GetAdvisorActivityFeed", GetAdvisorActivityFeedResponse, { callback });
};

const useGetMemberActivityFeed = (
  callback?: (r: GetMemberActivityFeedResponse) => void,
) => {
  return useProtoMethod<
    GetMemberActivityFeedRequest,
    GetMemberActivityFeedResponse
  >("GetMemberActivityFeed", GetMemberActivityFeedResponse, { callback });
};

const useGetAdvisorPublicActivityFeed = (
  callback?: (r: GetAdvisorPublicActivityFeedResponse) => void,
) => {
  return useProtoMethod<
    GetAdvisorPublicActivityFeedRequest,
    GetAdvisorPublicActivityFeedResponse
  >("GetAdvisorPublicActivityFeed", GetAdvisorPublicActivityFeedResponse, {
    callback,
  });
};

const useGetBotConversationFeed = (
  callback?: (r: GetBotConversationFeedResponse) => void,
) => {
  return useProtoMethod<
    GetBotConversationFeedRequest,
    GetBotConversationFeedResponse
  >("GetBotConversationFeed", GetBotConversationFeedResponse, { callback });
};

export {
  useGetAdvisorActivityFeed,
  useGetMemberActivityFeed,
  useGetAdvisorPublicActivityFeed,
  useGetBotConversationFeed,
};
